import React from 'react';
import Img from 'gatsby-image';
import styled, { css } from 'styled-components';
import { width, space, height, maxHeight } from 'styled-system';

const isBg = css`
	width: 100%;
	height: 100%;
	position: absolute !important;
	z-index: -1;
`;

const style = css`
	width: 100%;
	height: auto;
	margin-bottom: 0;
	display: inline-block;
	overflow: visible;
	object-fit: ${props => props.objectFit};
	width: ${props => props.icon && 'auto'};
	height: ${props => props.icon && 'auto'};

	${width}
	${space}
	${height}
	${maxHeight}
	${props => props.bg && isBg}
`;

const GatsbyImage = styled(Img)`
	${style}
`;

const StaticImage = styled.img`
	${style}
`;

const ImageStyled = ({ staticImg, ...rest }) => {
	if (staticImg) {
		return <StaticImage {...rest} />;
	}
	return <GatsbyImage {...rest} />;
};

export default ImageStyled;
